import { render, staticRenderFns } from "./AppSidebarHead.vue?vue&type=template&id=89290fa8&scoped=true&lang=pug"
import script from "./AppSidebarHead.vue?vue&type=script&lang=ts"
export * from "./AppSidebarHead.vue?vue&type=script&lang=ts"
import style0 from "./AppSidebarHead.vue?vue&type=style&index=0&id=89290fa8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89290fa8",
  null
  
)

export default component.exports